import React from 'react';
import { getCargoColor } from '../compartidos/utils';

function TabEquipo({
  teamMembers,
  showTeamForm, setShowTeamForm,
  newMemberName, setNewMemberName,
  newMemberEmail, setNewMemberEmail,
  newMemberRole, setNewMemberRole,
  addTeamMember, removeTeamMember, addingMember
}) {
  return (
    <div className="tab-content equipo-page">
      <section className="progress-section-v2">
        {/* Header */}
        <div className="critical-header-bar">
          <h2 className="equipo-page-title">Equipo</h2>
          <span className="progress-header-date">{teamMembers.length} miembro{teamMembers.length !== 1 ? 's' : ''} registrado{teamMembers.length !== 1 ? 's' : ''}</span>
        </div>

        {/* Botón agregar */}
        <div className="team-actions-row">
          <button
            className={`team-action-btn ${showTeamForm ? 'active-red' : 'green'}`}
            onClick={() => setShowTeamForm(!showTeamForm)}
          >
            {showTeamForm ? 'Ocultar Formulario' : '+ Agregar Miembro'}
          </button>
        </div>

        {/* Formulario para agregar miembros */}
        {showTeamForm && (
          <div className="team-form-container-v2">
            <div className="critical-title-row">
              <span className="critical-square" style={{ color: '#111827' }}>■</span>
              <span className="critical-title-text">Nuevo Miembro</span>
            </div>
            <form className="team-form" onSubmit={addTeamMember}>
              <input
                type="text"
                placeholder="Nombre del miembro"
                value={newMemberName}
                onChange={(e) => setNewMemberName(e.target.value)}
                className="team-input"
              />
              <input
                type="email"
                placeholder="Correo electrónico"
                value={newMemberEmail}
                onChange={(e) => setNewMemberEmail(e.target.value)}
                className="team-input"
              />
              <select
                value={newMemberRole}
                onChange={(e) => setNewMemberRole(e.target.value)}
                className="team-input"
                required
              >
                <option value="">Seleccionar cargo...</option>
                <option value="Gerente de Proyecto">Gerente de Proyecto</option>
                <option value="Administrador">Administrador</option>
                <option value="Jefe de terreno">Jefe de terreno</option>
                <option value="Supervisor">Supervisor</option>
                <option value="Calidad">Calidad</option>
                <option value="Administrador de obra">Administrador de obra</option>
                <option value="Oficina tecnica">Oficina tecnica</option>
                <option value="Jefe de Oficina Tecnica">Jefe de Oficina Tecnica</option>
                <option value="Jefe de Bodega">Jefe de Bodega</option>
                <option value="Oficina Central">Oficina Central</option>
              </select>
              <button 
                type="submit" 
                className="add-button"
                disabled={addingMember}
                style={{
                  opacity: addingMember ? 0.7 : 1,
                  cursor: addingMember ? 'not-allowed' : 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                  background: '#16a34a',
                  color: '#ffffff',
                  borderColor: '#16a34a'
                }}
              >
                {addingMember ? (
                  <>
                    <span style={{
                      width: '16px',
                      height: '16px',
                      border: '2px solid #ffffff',
                      borderTop: '2px solid transparent',
                      borderRadius: '50%',
                      animation: 'spin 0.6s linear infinite',
                      display: 'inline-block'
                    }}></span>
                    Agregando...
                  </>
                ) : (
                  'Agregar Miembro'
                )}
              </button>
            </form>
          </div>
        )}

        {/* Tabla de miembros */}
        <div className="team-members-container">
          <div className="critical-title-row">
            <span className="critical-square" style={{ color: '#111827' }}>■</span>
            <span className="critical-title-text">Miembros del Equipo</span>
            <span className="critical-count-badge" style={{ background: '#f3f4f6', color: '#111827' }}>{teamMembers.length}</span>
          </div>
          
          {teamMembers.length === 0 ? (
            <div className="team-empty-state">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="1.5" width="40" height="40" style={{ marginBottom: '12px' }}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z" />
              </svg>
              <h3>Sin miembros</h3>
              <p>Agrega miembros del equipo para enviarles notificaciones desde la Ruta Crítica</p>
            </div>
          ) : (
            <div className="table-wrapper">
              <table className="critical-table-email">
                <thead>
                  <tr>
                    <th style={{ width: '60px', textAlign: 'center' }}></th>
                    <th>Nombre</th>
                    <th>Cargo</th>
                    <th>Correo</th>
                    <th style={{ width: '90px', textAlign: 'center' }}>Acción</th>
                  </tr>
                </thead>
                <tbody>
                  {teamMembers.map((member, index) => (
                    <tr key={member.id} className={index % 2 === 0 ? 'row-even' : 'row-odd'}>
                      <td style={{ textAlign: 'center' }}>
                        <div
                          className="member-avatar-table"
                          style={{ background: getCargoColor(member.role) }}
                        >
                          {member.name.charAt(0).toUpperCase()}
                        </div>
                      </td>
                      <td>
                        <strong>{member.name}</strong>
                      </td>
                      <td>
                        <span className="status-badge" style={{ background: '#f9fafb', color: '#374151' }}>{member.role}</span>
                      </td>
                      <td style={{ fontSize: '13px', color: '#6b7280' }}>{member.email}</td>
                      <td style={{ textAlign: 'center' }}>
                        <button
                          className="btn-action btn-delete"
                          onClick={() => removeTeamMember(member.id)}
                          title="Eliminar miembro"
                        >
                          ✕
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}

export default TabEquipo;
